
export var ReportLibraryFilterKeys = {
  reportName: 'ReportName',
  reportType: 'ReportType',
  dataSource: 'DataSource',
  createdBy: 'CreatedBy',
  archivedReports: 'ArchivedReports',
};

export var ReportType = {
  type: 'Jobtrain Standard Reports'
};
export var ContentType = {
  json: 'application/json'
};

export var ExtensionType = {
  json: '.json'
};

